import React from 'react';
import './SupportLink.css';

const SupportLink = () => {
  return (
    <section className="support-section">
      <h2 className="support-title">Not finding what you need?</h2>
      <a href="#support" className="support-link">
        Get support &rarr;
      </a>
    </section>
  );
};

export default SupportLink;